import { render, staticRenderFns } from "./DownloadHomeThree.vue?vue&type=template&id=57b149f4&"
import script from "./DownloadHomeThree.vue?vue&type=script&lang=js&"
export * from "./DownloadHomeThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports